import React, { useEffect } from 'react';
import { useActions } from '../../store/actions';
import { useGlobalState } from '../../store';
import LayoutRoot from '../../components/LayoutRoot';
import Hero from './LandingHero';
import ChooseFarmersSection from './ChooseFarmersSection';
import CustomizePolicySection from './CustomizePolicySection';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import analytics from '../../services/analytics';
import CCPABanner from '../../components/CCPABanner';

import wlConfig from '../../constants/wlConfig';

const {
  featureFlags: { hasCCPABanner },
} = wlConfig;

const useStyles = makeStyles((theme) => {
  return {
    '@global': {
      body: {
        background: theme.palette.tenant.whiteDark,
      },
    },
  };
});

function LandingHomeView({ history }) {
  useEffect(() => {
    analytics.lead({ currency: 'USD' });
  }, []);

  useStyles();

  const { closeCCPABanner } = useActions();
  const { isCCPABannerOpen } = useGlobalState();

  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up('lg'));

  return (
    <LayoutRoot
      withRightsReservedFooter
      withTopNavigation
      withAlternateBackground={isDesktop}
    >
      {hasCCPABanner && (
        <CCPABanner
          isOpen={isCCPABannerOpen || isCCPABannerOpen === undefined}
          onClose={() => closeCCPABanner()}
          history={history}
        />
      )}
      <Hero />
      <ChooseFarmersSection />
      <CustomizePolicySection />
    </LayoutRoot>
  );
}

export default LandingHomeView;
